import uiRouter from '@uirouter/angularjs';

import { ImageLibraryControllerModule } from './imageLibrary.controller';
import template from './imageLibrary.html';
import './imageLibrary.scss';

export const ImageLibraryServiceModule = angular
    .module('app.components.imageLibrary.imageLibraryService', [
        uiRouter,
        ImageLibraryControllerModule
    ]).service('imageLibraryService', ($mdDialog) => {
        return {
            open: ({ event, multiSelect, context, associationTags, clearImage }) => {
                return $mdDialog.show({
                    controller: 'ImageLibraryController',
                    template,
                    parent: angular.element('body'),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        context,
                        associationTags: associationTags || [],
                        multiSelect,
                        clearImage
                    }
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/imageLibrary.service.js